import { EditIntegrationSecretModal } from '__pages/Settings/pages/ManageConnections/IntegrationSecrets/IntegrationSecretModal';
import { SetupAssistant } from './SetupAssistant';
import { NoPermissionModal } from './Tile/NoPermissionModal';
import type { usePluginEnable } from '../Details/usePluginEnable';

export const PluginEnableModals = ({
  pluginEnable,
  businessPluginAppsByApiName,
}: {
  pluginEnable: ReturnType<typeof usePluginEnable>;
  businessPluginAppsByApiName: Record<string, any>;
}) => {
  const {
    secretsToEdit,
    setupAssistantConfig,
    noPermissionModalProps,
    setupAssistantPending,
    handleCloseSecretsInlineModal,
    handleCloseSetupAssistant,
    canEditIntegrationSecrets,
    onChangeSetupAssistantConfig,
    onImportKZNFileStep,
  } = pluginEnable;

  return (
    <>
      {setupAssistantPending && setupAssistantConfig ? (
        <SetupAssistant
          onClose={handleCloseSetupAssistant}
          config={setupAssistantConfig}
          onChangeConfig={onChangeSetupAssistantConfig}
          businessPluginAppsByApiName={businessPluginAppsByApiName}
          onImportKZNFileStep={onImportKZNFileStep}
        />
      ) : null}
      {canEditIntegrationSecrets &&
      secretsToEdit.length > 0 &&
      !setupAssistantPending ? (
        <EditIntegrationSecretModal
          key={secretsToEdit[0].id}
          selectedIntegrationSecret={secretsToEdit[0]}
          // setSelectedIntegrationSecret is called after the modal is closed, either by create
          // or skip. In either case, we don't need to change anything in the state, just move on to the
          // next secret in the queue if available
          setSelectedIntegrationSecret={handleCloseSecretsInlineModal}
          initialMode
        />
      ) : null}
      <NoPermissionModal {...noPermissionModalProps} />
    </>
  );
};
